import CSVUploadConatiner from './CSVUploadContainer';
import CSVUpload from './service/CSVUpload';
import stores from './stores';

const CSVForm = {
    path:['/upload-csv'],
    exact: true,
    services: [new CSVUpload()],
    stores: stores,
    component: CSVUploadConatiner,
};

export default CSVForm;